// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__o5lzn","legend":"NewCustomer_legend__jgtjF","indicator":"NewCustomer_indicator__uOpTw","color":"NewCustomer_color__iMkbv"};